export default __webpack_public_path__ + "static/media/extra-dark.3feabc6c.svg";